import React, {useState, useEffect} from 'react';
// import logo from '../../logo.svg';
import {format, endOfWeek} from 'date-fns';
import './App.css';
import Table from '../../Components/Table';
import Header from '../../Components/Header';
import HeaderStats from '../../Components/HeaderStats';
import Footer from '../../Components/Footer';
import headerImg from '../../Assets/header_v2.jpg';
import headerImgMobile from '../../Assets/header-mobile_v2.jpg';

function App() {
  // const [loading, setLoading] = useState(false);
  const [activeTable, setActiveTable] = useState(0);
  const [dateRange] = useState('all');
  const [width, setWidth] = useState(window.innerWidth);
  const [urls, setUrls] = useState([
    'https://www.beyondthewhiteboard.com/tiggy_home_alone_gym_alltime_scores?per_page=20&page=',
    'https://crossfit.btwb.com/tiggy/homealone-alltime-teams-production.json',
    'https://www.beyondthewhiteboard.com/tiggy_home_alone_member_alltime_scores?public=true&per_page=20&page=',
    'https://crossfit.btwb.com/tiggy/homealone-alltime-sitestats-production.json'
  ]);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });
  

  useEffect(() => {
    if(dateRange === 'all') {
      setUrls([
        'https://www.beyondthewhiteboard.com/tiggy_home_alone_gym_alltime_scores?per_page=20&page=',
        'https://crossfit.btwb.com/tiggy/homealone-alltime-teams-production.json',
        'https://www.beyondthewhiteboard.com/tiggy_home_alone_member_alltime_scores?public=true&per_page=20&page=',
        'https://crossfit.btwb.com/tiggy/homealone-alltime-sitestats-production.json'
      ]);
    } else {
      setUrls([
        'https://www.beyondthewhiteboard.com/tiggy_home_alone_gym_weekly_scores?page=1&per_page=20&date=' + format(new Date(), 'y-MM-dd'),
        'https://crossfit.btwb.com/tiggy/homealone-' + format(endOfWeek(new Date()), 'y-MM-dd') + '-teams-production.json',
        'https://crossfit.btwb.com/tiggy/homealone-' + format(endOfWeek(new Date()), 'y-MM-dd') + '-members-production.json',
        'https://crossfit.btwb.com/tiggy/homealone-' + format(endOfWeek(new Date()), 'y-MM-dd') + '-sitestats-production.json'
      ])
    };

    return () => {};
  }, [dateRange]);

  return (
    <div className="App">
      <Header />
      <div className="donate-banner w-100 pa3 white flex items-center">

        <p className="f6 f5-ns mv0 w-80 tl"> </p> 
        <div className="w-20">
        </div>
      </div>
      <div className="hero-img tl">
        {width > 800 &&
          <img 
            alt="header desktop"
            src={headerImg}
            className="db w-100"
          />
        }
        {width <= 800 &&
          <img 
            alt="header mobile"
            src={headerImgMobile}
            className="db w-100"
          />
        }
      </div>
      <div className="summary flex items-center bg-white pa3">
        <div className="w-50 tl lh-copy pr2">
          Starting March 25th, earn points for various movements performed by yourself, your team, and/or your gym. Yes, being quarantined is lonely, but we teamed up with Rogue to bring you a fun way to stay connected. <strong>#DontWeaken™.</strong>
        </div>
        <div className="header-link w-50 tc">
          <a 
            className="di"
            href="https://btwb.blog/2020/03/25/dontweaken-challenge/">
            <div className="btn di pv2 ph3 bg-blue br1 white">How To Join</div>
          </a>   <a 
            className="di"
            href="https://www.roguefitness.com/dont-weaken">
            <div className="btn di ml2 mt3 pv2 ph3 bg-rogue-orange br1 white">Don't Weaken™ Gear</div>
          </a>
        </div>
      </div>
      {/*<div className="switcher mt4">
        <div className="flex mh3">
          <div 
            className={'tab w-50 tc pt3 pb3 pointer' + (dateRange === 'all' ? ' active-tab' : '')} 
            onClick={setDateRange.bind(this, 'all')}>
            All Time
          </div>
          <div 
            className={'tab w-50 tc pt3 pb3 pointer' + (dateRange === 'week' ? ' active-tab' : '')}
            onClick={setDateRange.bind(this, 'week')}>
            Weekly
          </div>
        </div>
      </div>*/}
      <div className="header-stats mt4">
        <HeaderStats 
          url={urls[3]}
        />
      </div>
      <div className="tab-menu mh3 mt4">
        <div className="db tl">
          <label 
            onClick={() => setActiveTable(0)} 
            className={'tab tc pv3 ph4 bg-animate pointer' + (activeTable === 0 ? ' active-tab' : '')}>
            Gyms
          </label>
          <label 
            onClick={() => setActiveTable(1)} 
            className={'tab tc pv3 ph4 bg-animate pointer' + (activeTable === 1 ? ' active-tab' : '')}>
            Teams
          </label>
          <label 
            onClick={() => setActiveTable(2)} 
            className={'tab tc pv3 ph4 bg-animate pointer' + (activeTable === 2 ? ' active-tab' : '')}>
            Individuals
          </label>
        </div>
      </div>
      <div className="tables-wrapper ph3">
        <Table
          activeTable={activeTable}
          url={urls[0]}
          idx={0}
          type={'Gym'}
        />
        <Table
          activeTable={activeTable}
          url={urls[1]}
          idx={1}
          type={'Team'}
        />
        <Table
          activeTable={activeTable}
          url={urls[2]}
          idx={2}
          type={'Individual'}
        />
      </div>
      <Footer />
    </div>
  );
}

export default App;